import 'reflect-metadata';
import { Expose } from 'class-transformer';
import { UserRoleEnum } from '../../enum/user-role.enum';

export class UserDetailsDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'job_title' })
  jobTitle: string;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'user_role' })
  role: UserRoleEnum;
}
